"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.perfEntryToEventEndObj = exports.getLatestPerfEntryByName = void 0;
const events_1 = require("../constants/events");
const createEndEvent_1 = __importDefault(require("../events/createEndEvent"));
const ENTRY_TYPES = { MARK: 'mark', MEASURE: 'measure' };
/**
 * Get the latest PerformanceEntry by name. If the entry cannot be found, return
 * `undefined`.
 */
function getLatestPerfEntryByName(name) {
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return undefined;
    const { performance } = window;
    const perfEntries = performance.getEntriesByName(name);
    // This will be `undefined` if there are no entries
    return perfEntries[perfEntries.length - 1];
}
exports.getLatestPerfEntryByName = getLatestPerfEntryByName;
/**
 * Create an EndEvent from a PerformanceEntry. If `entry` is `undefined`, return
 * an empty object as the EndEvent.
 */
function perfEntryToEventEndObj(entry) {
    if (!entry)
        return {};
    const { name, startTime, duration } = entry;
    const isPerfEntryTypeMark = entry.entryType === ENTRY_TYPES.MARK;
    const isPerfEntryTypeMeasure = entry.entryType === ENTRY_TYPES.MEASURE;
    let time = events_1.ERROR_METRIC_VALUE;
    let eventName = name;
    if (isPerfEntryTypeMark)
        time = startTime;
    else if (isPerfEntryTypeMeasure) {
        time = duration;
        eventName = name.replace(events_1.DYNAMIC_EVENT_END_SUFFIXES_REGEX_NEW, '');
    }
    return (0, createEndEvent_1.default)(eventName, time);
}
exports.perfEntryToEventEndObj = perfEntryToEventEndObj;
